import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { concatMap, map, mergeMap } from 'rxjs/operators';
import { UserSessionService } from './user-session.service';
import { AzureAuthService } from './azure-auth.service';
import * as CryptoJS from 'crypto-js';
import { globals } from '../../../app.globals';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppAuthService {
  public userData: any;
  public showLoader = false;
  afAuth: any;
  ngZone: any;
  private authEndpoint = '/authenticate/login';
  googleUser = false;
  private AUTH_ENDPOINT = environment.AUTH_ENDPOINT;
  private AUTH_CLIENT_ID = "apiclient";
  private AUTH_CLIENT_SECRET = "ip8YRYfG";
  private AUTH_SCOPE = "roles api.v1";
  private _authToken: any;
  tokenFromUI: string = "0123456789123456";

  constructor(
    private http: HttpClient,
    public router: Router,
    public toster: ToastrService,
    private cookie: CookieService,
    //private socialAuthService: AuthService,
    private userSession: UserSessionService,
    private azureAuthService: AzureAuthService,
    private httpClient:HttpClient,
  ) { }


  // SignIn(email, password) {
  //   return this.afAuth.auth.signInWithEmailAndPassword(email, password)
  //     .then((result) => {
  //       if (result.user.emailVerified !== true) {

  //         this.showLoader = true;
  //       } else {
  //         this.showLoader = false;
  //         this.ngZone.run(() => {
  //           this.router.navigate(['/auth/login']);
  //         });
  //       }
  //     }).catch((error) => {
  //       this.toster.error('You have enter Wrong Email or Password.');
  //     })
  // }


  login(username, password) {
    return this.http.post(globals.QQT_ROOT + this.authEndpoint, {
      UserName: username,
      Password: password,
    }).pipe(map((response: any) => {
      this.validateAuthResponse(response);
      this.showLoader = true;
      return response;
    }));
  } 

  logInAuth(username, password) {
    const body = new HttpParams()
        .set('username', this.encryptUsingAES256(username))
        .set('password', this.encryptUsingAES256(password))
        .set('decryption', "true")
        .set('grant_type', "password")
        .set('client_secret', this.AUTH_CLIENT_SECRET)
        .set('scope', this.AUTH_SCOPE)
        .set('client_id', this.AUTH_CLIENT_ID)
        .set('isgoogle', "false")
        .set('token', "")
        .set('isgoogle', "false");
        
        return this.http.post<any>(this.AUTH_ENDPOINT, body.toString(), {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        }).pipe(map((response: any) => {
            this.azureAuthService.setAuthToken(response.token_type + ' ' + response.access_token);
            this.validateAuthResponse(response, true);
            this.showLoader = true;
            return response;
          }));
  }

  loginWithGoogle(emailid, token) {
    return this.http.post(globals.QQT_ROOT + this.authEndpoint, {
      UserName: '',
      Password: '',
      EmailId: emailid,
      Token: token,
    }).pipe(map((response: any) => {
      this.validateAuthResponse(response, true);
      this.showLoader = true;
      return response;
    }));
  }

  logInAuthGoogle(emailid, token) {
    const body = new HttpParams()
        .set('username', this.encryptUsingAES256(emailid))
        .set('password', this.encryptUsingAES256('1234'))
        .set('decryption', "true")
        .set('grant_type', "password")
        .set('client_secret', this.AUTH_CLIENT_SECRET)
        .set('scope', this.AUTH_SCOPE)
        .set('client_id', this.AUTH_CLIENT_ID)
        .set('isgoogle', "true")
        .set('token', token)
        
        return this.http.post<any>(this.AUTH_ENDPOINT, body.toString(), {
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        })
          .pipe(map((response: any) => {
            this.azureAuthService.setAuthToken(response.token_type + ' ' + response.access_token);
            this.validateAuthResponse(response, true);
            this.showLoader = true;
            return response;
          }));
  }

  validateAuthResponse(resp, isGoogleUser?) {
    this.googleUser = isGoogleUser;
    //if (resp.message_type === 'success') {
    if (resp && resp.access_token.length>0) {
      this.userSession.setUserFromAuthResponse(resp);
      return resp;
    }
    if (this.router.routerState.snapshot.url.indexOf('auth/login') < 0) {
      this.logoutUser();
      this.showLoader = false;
    }
    this.showLoader = false;
    throw new Error(resp.Message || 'Invalid User Details!');
  }

  setSession(username, password, email, token, rememberMe?) {
    const userCredentials = { un: this.encryptOld(username), pw: this.encryptOld(password), em: this.encryptOld(email), tk: this.encryptOld(token) };
    const authStr = btoa(JSON.stringify(userCredentials));
    const expiredDate = new Date();
    expiredDate.setDate(expiredDate.getDate() + 1);
    if (rememberMe) {
      this.cookie.set(globals.sessionCookie, authStr, expiredDate, '/', undefined, false, "Lax");
    } else {
      this.cookie.set(globals.sessionCookie, authStr, 0, '/', undefined, false, "Lax");
    }
  }

  setSessionDirect(username: string, password: string, email: string, token: string, rememberMe?: boolean) {
  const userCredentials = {
    un: username,
    pw: password,
    em: email,
    tk: this.encryptOld(token)
  };

  const authStr = btoa(JSON.stringify(userCredentials));

  const expiredDate = new Date();
  expiredDate.setDate(expiredDate.getDate() + 1);

  if (rememberMe) {
    this.cookie.set(globals.sessionCookie, authStr, expiredDate, '/', undefined, false, "Lax");
  } else {
    this.cookie.set(globals.sessionCookie, authStr, 0, '/', undefined, false, "Lax");
  }
}

  getAuthData() {
    return this.cookie.get(globals.sessionCookie);
  }

  logoutUser(options?: { noReload?: boolean }) {
    if (this.googleUser) {
      // this.socialAuthService.signOut();
    }
    this.showLoader = false;
    this.cookie.delete(globals.sessionCookie, '/');
    this.azureAuthService.clearAuthToken();
    this.deleteAllAccessibleCookies();

    if (options?.noReload) {
      this.router.navigate(['/auth/login']); 
    } else {
      window.location.href = '/auth/login';
    }
  }

  private deleteAllAccessibleCookies() {
    document.cookie.split(';').forEach(cookie => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    });
  }


  
  encryptUsingAES256(text) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(text), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString().replace(/\+/g, "%2B");
  }
  
  encryptOld(text) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(text), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }

  decryptUsingAES256(text: any) {
    let _key = CryptoJS.enc.Utf8.parse(this.tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(this.tokenFromUI);

    return CryptoJS.AES.decrypt(
      text, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8).replace(/\"/g, "");
  }

  getTokenAuthenticate(){
      const userData = JSON.parse(atob(this.getAuthData()));
      const body = new HttpParams()
      .set('username', userData['un'])
      .set('password', userData['pw'])
      .set('decryption', "true")
      .set('grant_type', "password")
      .set('client_secret', this.AUTH_CLIENT_SECRET)
      .set('scope', this.AUTH_SCOPE)
      .set('client_id', this.AUTH_CLIENT_ID)
      .set('isgoogle', "false")
      .set('token', "")
      .set('isgoogle', "false");
      
      return this.httpClient.post(<any>this.AUTH_ENDPOINT, body.toString(),{
          headers: new HttpHeaders()
              .set('Content-Type', 'application/x-www-form-urlencoded')
          })
          .pipe(map((data: any) => {
              this.azureAuthService.setAuthToken(data.token_type + ' ' + data.access_token);
              return data;
          }));
  }
}
